export function cx(...classNames: (string | undefined | null | false)[]): string {
  return classNames.filter((it) => typeof it === "string").join(" ");
}
